// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".breadcrumb-container .ant-breadcrumb-separator {\n  margin-inline: 1px !important;\n}\n", "",{"version":3,"sources":["webpack://./src/components/CustomBreadCrumb/CustomBreadCrumb.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;AAC/B","sourcesContent":[".breadcrumb-container .ant-breadcrumb-separator {\n  margin-inline: 1px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
